import { LobbyWidget } from '@bonanza-social/moonlight';
import { memo, useMemo } from 'react';
import { StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { useTranslation } from '@bonanza-social/i18n';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectDailyGift } from '@bonanza-social/daily-rewards/state';
import {
  selectFreeSpins,
  selectFreeSpinsDataState,
} from '../state/rewards.slice';
import { useWheelSpinsCount } from '../hooks/useWheelSpinsCount';

function RewardsLobbyWidget() {
  const [t] = useTranslation('rewards');
  const { wheelSpinsCount } = useWheelSpinsCount();

  const freeSpinsDataState = useSelector(selectFreeSpinsDataState);
  const freeSpins = useSelector(selectFreeSpins);
  const hasFreeSpins = useMemo(
    () => freeSpinsDataState === 'fulfilled' && freeSpins.length > 0,
    [freeSpins, freeSpinsDataState],
  );

  // TODO: Prevent fetching free spins until we enable them
  // useFocusEffect(
  //   useCallback(() => {
  //     if (freeSpinsDataState === 'idle') {
  //       dispatch(fetchFreeSpins());
  //     }
  //   }, [dispatch, freeSpinsDataState]),
  // );

  const dailyGift = useSelector(selectDailyGift);
  const hasDailyGift = useMemo(
    () => dailyGift?.status === 'Pending',
    [dailyGift],
  );

  const hasUnread = useMemo(
    () => hasDailyGift || hasFreeSpins || wheelSpinsCount > 0,
    [hasDailyGift, hasFreeSpins, wheelSpinsCount],
  );

  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleClick = () => {
    navigation.navigate('Rewards');
  };

  return (
    <LobbyWidget
      image="rewards.lobbyWidgetIcon"
      label={t('widgetLabel')}
      onClick={handleClick}
      hasUnread={hasUnread}
      showUnreadBadge
    />
  );
}

export default memo(RewardsLobbyWidget);
